var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "app-modal",
    {
      staticClass: "modalModelo",
      attrs: { titulo: "Adicionar modelo" },
      on: {
        closeModal: function($event) {
          return _vm.$emit("closeModal")
        }
      }
    },
    [
      _c(
        "template",
        { slot: "body" },
        [
          _c(
            "validation-observer",
            { ref: "validation", attrs: { tag: "form" } },
            [
              _vm.hasPermissaoNotificar ||
              _vm.exibirTitulo ||
              _vm.exibirDespachoReurb ||
              _vm.exibirDespacho ||
              _vm.exibirModeloRegistroImovel ||
              _vm.exibirJustificativa ||
              _vm.exibirModeloExtratoSentenca
                ? _c(
                    "div",
                    { staticClass: "group" },
                    [
                      _c("p", { staticClass: "required" }, [
                        _vm._v(
                          "Selecione qual tipo de modelo deseja adicionar:"
                        )
                      ]),
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _vm.exibirDespacho
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 1 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo de despacho")]
                                      )
                                    : _vm._e(),
                                  _vm.hasPermissaoNotificar
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 2 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo de notificação")]
                                      )
                                    : _vm._e(),
                                  _vm.exibirTitulo
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 3 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo do título")]
                                      )
                                    : _vm._e(),
                                  _vm.exibirDespachoReurb && _vm.isMaranhao
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 4 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo de despacho dinâmico")]
                                      )
                                    : _vm._e(),
                                  _vm.exibirDespachoReurb && !_vm.isMaranhao
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 4 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo de despacho")]
                                      )
                                    : _vm._e(),
                                  _vm.exibirModeloRegistroImovel &&
                                  !_vm.isMaranhao
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 5 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo de registro de imóvel")]
                                      )
                                    : _vm._e(),
                                  _vm.exibirDespachoVistoria
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 6 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo app vistoria")]
                                      )
                                    : _vm._e(),
                                  _vm.exibirModeloExtratoSentenca
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 8 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "Modelo extrato de sentença dinâmico"
                                          )
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.exibirModeloJustificativa &&
                                  (_vm.isMaranhao || _vm.isAmapa)
                                    ? _c(
                                        "el-radio",
                                        {
                                          staticClass: "input",
                                          class: { erro: errors.length },
                                          attrs: { label: 7 },
                                          model: {
                                            value: _vm.modelo.tipoModelo,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.modelo,
                                                "tipoModelo",
                                                $$v
                                              )
                                            },
                                            expression: "modelo.tipoModelo"
                                          }
                                        },
                                        [_vm._v("Modelo justificativa")]
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          3765462864
                        )
                      })
                    ],
                    1
                  )
                : _c("div", { staticClass: "group" }, [
                    _c("p", [_vm._v("Adicionar um modelo de despacho")])
                  ]),
              _c(
                "div",
                { staticClass: "group mt-1" },
                [
                  _c("p", { staticClass: "required" }, [
                    _vm._v(
                      _vm._s(
                        _vm.getLabelDescricaoTexto(_vm.modelo.tipoModelo)
                      ) + ":"
                    )
                  ]),
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function(ref) {
                          var errors = ref.errors
                          return [
                            _c("el-input", {
                              staticClass: "input",
                              class: { erro: errors.length },
                              model: {
                                value: _vm.modelo.descricaoTexto,
                                callback: function($$v) {
                                  _vm.$set(_vm.modelo, "descricaoTexto", $$v)
                                },
                                expression: "modelo.descricaoTexto"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c("div", { staticClass: "group mt-1" }, [
                _c("div", [
                  _c(
                    "div",
                    { staticClass: "flex" },
                    [
                      _c("p", { staticClass: "required" }, [
                        _vm._v(
                          _vm._s(
                            _vm.getLabelTextoModelo(_vm.modelo.tipoModelo)
                          ) + ":"
                        )
                      ]),
                      _vm.modelo.tipoModelo === 2 &&
                      !_vm.isMaranhao &&
                      !_vm.isAmapa &&
                      !_vm.isBahia &&
                      _vm.modelo.tipoModelo !== 6
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "tooltip",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _c("span", [
                                  _vm._v(
                                    "Para criar um modelo com o nome do interessado, número do processo,"
                                  ),
                                  _c("br")
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "e/ou outros dados do processo, utilize conforme exemplos abaixo:"
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Processo nº <numero_processo>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Interessado <nome_interessado>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Município <municipio>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Data emissão <data_emissao> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "Município emissor <municipio_emissor> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Local emissão <local_emissao> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "Área georreferenciamento <area_georreferenciamento> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [_vm._v("Área <area> "), _c("br")]),
                                _c("li", [
                                  _vm._v("Perfil emissor <perfil_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Nome do emissor <nome_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "Número da notificação <numero_notificacao> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "CPF do interessado  <cpf_interessado> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "RG do interessado  <rg_interessado> "
                                  ),
                                  _c("br")
                                ])
                              ]),
                              _c("i", { staticClass: "el-icon-info icon-info" })
                            ],
                            2
                          )
                        : _vm._e(),
                      (_vm.modelo.tipoModelo === 4 ||
                        _vm.modelo.tipoModelo === 5) &&
                      !_vm.isAmapa &&
                      !_vm.isBahia
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "tooltip",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _c("span", [
                                  _vm._v(
                                    "Para criar um modelo de despacho com o nome do interessado, número do processo,"
                                  ),
                                  _c("br")
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "e/ou outros dados do processo, utilize conforme exemplos abaixo:"
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Processo nº <numero_processo>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Interessado <nome_interessado>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Município <municipio>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Bairro <bairro> "),
                                  _c("br")
                                ]),
                                _c("li", [_vm._v("Dia <dia> "), _c("br")]),
                                _c("li", [_vm._v("Mês <mes> "), _c("br")]),
                                _c("li", [_vm._v("Ano <ano> "), _c("br")]),
                                _c("li", [
                                  _vm._v(
                                    "Município emissor <municipio_emissor> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Área <area_georreferenciamento> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Perfil emissor <perfil_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Nome do emissor <nome_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "CPF do interessado  <cpf_interessado> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "RG do interessado  <rg_interessado> "
                                  ),
                                  _c("br")
                                ])
                              ]),
                              _c("i", { staticClass: "el-icon-info icon-info" })
                            ],
                            2
                          )
                        : _vm._e(),
                      (_vm.isAmapa || _vm.isBahia) &&
                      _vm.modelo.tipoModelo === 4
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "tooltip",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _c("span", [
                                  _vm._v(
                                    "Para criar um modelo de despacho com o nome do interessado, número do processo,"
                                  ),
                                  _c("br")
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "e/ou outros dados do processo, utilize conforme exemplos abaixo:"
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Processo nº <numero_processo>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Interessado <nome_interessado>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Município <municipio>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Bairro <bairro> "),
                                  _c("br")
                                ]),
                                _c("li", [_vm._v("Dia <dia> "), _c("br")]),
                                _c("li", [_vm._v("Mês <mes> "), _c("br")]),
                                _c("li", [_vm._v("Ano <ano> "), _c("br")]),
                                _c("li", [
                                  _vm._v(
                                    "Município emissor <municipio_emissor> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Área <area_georreferenciamento> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Perfil emissor <perfil_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Nome do emissor <nome_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "CPF do interessado <cpf_interessado> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("RG do interessado <rg_interessado> "),
                                  _c("br")
                                ])
                              ]),
                              _c("i", { staticClass: "el-icon-info icon-info" })
                            ],
                            2
                          )
                        : _vm._e(),
                      (_vm.isAmapa || _vm.isBahia) &&
                      (_vm.modelo.tipoModelo === 2 ||
                        _vm.modelo.tipoModelo == 7)
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "tooltip",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _c("span", [
                                  _vm._v(
                                    "Para criar um modelo de notificação com o nome do interessado, número do processo,"
                                  ),
                                  _c("br")
                                ]),
                                _c("span", [
                                  _vm._v(
                                    "e/ou outros dados do processo, utilize conforme exemplos abaixo:"
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Processo nº <numero_processo>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Interessado <nome_interessado>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Município <municipio>"),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Bairro <bairro> "),
                                  _c("br")
                                ]),
                                _c("li", [_vm._v("Dia <dia> "), _c("br")]),
                                _c("li", [_vm._v("Mês <mes> "), _c("br")]),
                                _c("li", [_vm._v("Ano <ano> "), _c("br")]),
                                _c("li", [
                                  _vm._v(
                                    "Município emissor <municipio_emissor> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Área <area_georreferenciamento> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Perfil emissor <perfil_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("Nome do emissor <nome_emissor> "),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "CPF do interessado <cpf_interessado> "
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v("RG do interessado <rg_interessado> "),
                                  _c("br")
                                ])
                              ]),
                              _c("i", { staticClass: "el-icon-info icon-info" })
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.modelo.tipoModelo === 8
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "tooltip",
                              attrs: { effect: "dark", placement: "top" }
                            },
                            [
                              _c("template", { slot: "content" }, [
                                _c("span", [
                                  _vm._v(
                                    "Para criar um modelo de extrato de sentença, utilize conforme exemplos abaixo:"
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "Nº extrato de sentença <numero_extrato_sentenca>"
                                  ),
                                  _c("br")
                                ]),
                                _c("li", [
                                  _vm._v(
                                    "Nº processo Interessado municipio <numero_processo_nome_interessado_municipio>"
                                  ),
                                  _c("br")
                                ])
                              ]),
                              _c("i", { staticClass: "el-icon-info icon-info" })
                            ],
                            2
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c("validation-provider", {
                        attrs: { rules: "required" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(ref) {
                              var errors = ref.errors
                              return [
                                _c("app-editor-texto", {
                                  class: { erro: errors.length },
                                  attrs: { value: _vm.modelo.textoModelo },
                                  on: { onTextChange: _vm.onTextChange }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ])
              ])
            ]
          )
        ],
        1
      ),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "flex-between" },
          [
            _c(
              "el-button",
              {
                on: {
                  click: function($event) {
                    return _vm.$emit("closeModal")
                  }
                }
              },
              [_vm._v("Cancelar  "), _c("div", { staticClass: "fa fa-times" })]
            ),
            _c("salvar-modelo", {
              on: {
                "update:modelValue": function($event) {
                  return _vm.saveModelo($event)
                }
              },
              model: {
                value: _vm.saveModelo,
                callback: function($$v) {
                  _vm.saveModelo = $$v
                },
                expression: "saveModelo"
              }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7694046a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7694046a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppModalAdicionarModelo.vue
// module id = null
// module chunks = 